import TemplateView from '../../../TemplateView'

export default class WelcomeScreenLightboxHeader extends TemplateView
{
    templateHtml() {
        return `<div></div>`
    }

    getCloseButtonEl() {
        return this.find('.close-button')
    }

    templateHtml() {
        return '<table class="dialog-header">' +
               '    <tr>' +
               '        <td>' +
               '            <div class="close-button">' +
               '                <div id="closeProjectLightBoxBtn" class="closeButton"></div>' +
               '                <div class="disabledCloseButton"></div>' +
               '            </div>' +
               '' +
               '            <div class="lightBoxTitle">' +
               '            </div>' +
               '        </td>' +
               '    </tr>' +
               '</table>'
    }
}


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/components/WelcomeScreenLightboxHeader.js